import React, { Fragment, useState } from 'react';
import Button from '../../../Button';
import Modal from '../../../common/Modal';
import Form from './form';
import { ToastContainer } from 'react-toastify';
import styles from "./WorkOrder.module.sass";

const WorkOrder = ({ workOrderTypes, detailFields = {}, modelName = undefined, modelId = undefined, modelType = undefined, isLink = false, schoolName, studentName, studentID, teacher, email, phone }) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  // When we have a known model (Student or OrderPackage), redirect to the new form instead of opening modal
  const handleCreateClick = () => {
    if (modelId && modelType) {
      const params = new URLSearchParams({
        model_type: modelType,
        model_id: modelId,
        return_to: window.location.pathname + window.location.search
      });
      window.location.href = `/admin/work_orders/new?${params.toString()}`;
    } else {
      openModal();
    }
  };

  return (
    <Fragment>
      {!isLink && (
        <ToastContainer
          position="bottom-left"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      )}

      <Modal
        modalIsOpen={isOpen}
        closeModal={closeModal}
        contentLabel={`Create Work Order ${modelName && `for ${modelName}`}`}
        headerText={`Create Work Order ${modelName && `for ${modelName}`}`}
      >
        <Form closeModal={closeModal} workOrderTypes={workOrderTypes} detailFields={detailFields} modelType={modelType} modelId={modelId} schoolName={schoolName} studentName={studentName} studentID={studentID} teacher={teacher} email={email} phone={phone} />
      </Modal>

      {isLink ? <a onClick={handleCreateClick} className={styles.link}>Create WO</a> : <Button onClick={handleCreateClick}>Create Work Order</Button>}
    </Fragment>
  )
}

export default WorkOrder;
